import dynamic from 'next/dynamic'

export const Disclaimers = dynamic(() => import('./disclaimers'))
